export function isDigit(value) {
    return /^\d*$/.test(value || '');
}
